import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import blogApi from "../../../api/blogApi";
import SideBlock from '../SideBlock';

class BlogListSideBlocks extends Component {

    constructor(props)
    {
        super(props);
        this.state = {     
            arrBlog : []            
        }

        this.getBlogs = this.getBlogs.bind(this);
    }

    componentWillMount() { 
    }

    componentDidMount() {
        this.getBlogs();
    }
  
    componentWillUnmount() {
        
    }
    
    componentDidUpdate() {
        window.playVideo();
    }

    componentWillReceiveProps(newProps) {
        this.getBlogs();
    }   

    getBlogs() {
        blogApi.getBlogsWithPage(1, '', '', '', 'u', '',5).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    arrBlog: json.data.data.length > 5 ? json.data.data.slice(0, 5) : json.data.data
                });                                
                
            } else if (json.status !== 200) {
                
            } 
        })
    }

    render() {
        return (
            <div className="side-box">
                <h2 className="heading">{this.props.title}</h2>
                <ul className="post-list list-unstyled">
                    {
                        this.state.arrBlog.map((blog, key) => (
                            <SideBlock 
                                key         = {key}
                                business    = {blog.business} 
                                id          = {blog.id} 
                                title       = {blog.title}
                                image       = {blog.media_filename} 
                                media_type  = {blog.media_filetype}
                                isListPage  = {true}
                                onOtherBlog = {(business, id) => this.onOtherBlog(business, id)}
                            />
                        ))
                    }
                </ul>  
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(BlogListSideBlocks);